import { getExceptionMessage } from "../../exceptions/helpers/getExceptionMessage.ts";

/** El paso del modal "Crear expediente" donde se captura "Folio del contrato anterior". */
export const PREVIOUS_FOLIO_STEP = 1;

/**
 * Códigos con los que el backend rechaza la creación por culpa del folio anterior.
 * F008: ese folio ya tiene otra renovación activa. (F007 habla de REACTIVAR una
 * renovación, no de crearla, así que al crear no puede llegar.)
 */
const PREVIOUS_FOLIO_ERROR_CODES = ["F008"] as const;

/**
 * MB-379 — ¿el rechazo al crear el expediente se arregla corrigiendo el folio anterior?
 *
 * El thunk `createFolder` rechaza con el MENSAJE del catálogo, no con el código, así que
 * se compara contra ese mismo catálogo: si el texto de F008 cambia, los dos lados cambian
 * juntos.
 */
export const isPreviousFolioError = (message: string): boolean =>
  PREVIOUS_FOLIO_ERROR_CODES.some(
    (code) => getExceptionMessage(code, "") === message,
  );
